<div class="row">
  <div class="col-xl-12 col-sm-6">
    <div class="card crypto-main-card">
      <div class="card-body">
        <div class="deposit-wrap">
          <div>
            <h5>{{ 'Cryptocurrency just got even better.' | translate }}</h5>
            <p>{{ 'Lorem Ipsum is simply dummy text' | translate }}</p>
            <button class="btn btn-white f-w-500">{{ 'Deposit Now' | translate }}</button>
          </div>
          <img src="assets/images/dashboard-4/crypto.png" alt="crypto" />
        </div>
      </div>
    </div>
  </div>
  <div class="col-xl-12 col-sm-6">
    <app-average [data]="averageSales"></app-average>
  </div>
  <div class="col-xl-12 col-sm-6">
    <app-average [data]="averageProfit"></app-average>
  </div>
  <div class="col-xl-12 col-sm-6">
    <app-average [data]="averageVisits"></app-average>
  </div>
  <div class="col-sm-12">
    <app-transactions></app-transactions>
  </div>
</div>
